import {Component, input, OnInit} from '@angular/core';
import {
	AbstractControl,
	UntypedFormArray,
	UntypedFormBuilder,
	UntypedFormGroup,
	ValidationErrors,
	Validators
} from '@angular/forms';
import dayjs from 'dayjs';
import {StepComponent} from '../../base/step.component';
import {ToastService} from '../../core/services/toast/toast.service';
import {FinanceDeminimi} from '../../models/finance-deminimi.model';
import {getIsoFormat} from '../../core/utils/iso-format.util';
import {convertPrice} from '../../core/utils/convert-price.util';
import {TripleAnwer} from '../../models/triple-answer.enum';
import {SubsidyType} from '../../models/subsidy-type.type';

@Component({
	selector: 'tvsub-deminimis-step',
	templateUrl: './deminimis-step.component.html',
	styleUrls: ['./deminimis-step.component.scss'],
	standalone: false
})
export class DeminimisStepComponent extends StepComponent<any> implements OnInit {
	steps = input.required<string[]>();
	type = input.required<SubsidyType>();

	TripleAnwer = TripleAnwer;

	constructor(private fb: UntypedFormBuilder, toastService: ToastService) {
		super(toastService);
	}

	ngOnInit() {
		if (!this.subsidy.financeDeminimis!.length) {
			this.subsidy.financeDeminimis = [new FinanceDeminimi()];
		}

		const list = this.subsidy.financeDeminimis!.map((fd: any) => this.createDeminimiGroup(fd));

		this.form = this.fb.group(
			{
				financeDeminimis: this.fb.array(list),
				receivedDeminimis: [this.subsidy.receivedDeminimis, Validators.required],
			},
			{validators: this.totalValidator}
		);
	}

	addFinanceDeminimi() {
		const list = this.form.get('financeDeminimis') as UntypedFormArray;
		list.push(this.createDeminimiGroup(new FinanceDeminimi()));
	}

	removeFinanceDeminimi(index: number) {
		const list = this.form.get('financeDeminimis') as UntypedFormArray;
		list.removeAt(index);
	}

	isFormValid(valid: boolean = true, dontTriggerInvalidForm: boolean = false): boolean {
		this.resetInvalidForm();

		if (
			this.form.value.receivedDeminimis === TripleAnwer.NO ||
			this.form.value.receivedDeminimis === TripleAnwer.NOT_APPLICABLE ||
			(valid && this.form.valid)
		) {
			return true;
		}

		this.showErrors = true;

		if (!dontTriggerInvalidForm) {
			this.onInvalidForm();
		}

		return false;
	}

	// protected getFormValue(): any {
	// 	if (this.form.value.receivedDeminimis === TripleAnwer.NO || this.form.value.receivedDeminimis === TripleAnwer.NOT_APPLICABLE || this.form.valid) {
	// 		return this.form.value;
	// 	}
	//
	// 	this.showErrors = true;
	// 	this.onInvalidForm();
	//
	// 	return null;
	// }

	protected getData(formData: any): any {
		if (formData.receivedDeminimis === TripleAnwer.YES) {
			formData.financeDeminimis = formData.financeDeminimis.map((fd: any) => {
				fd.grantDate = getIsoFormat(fd.grantDate);
				fd.totalAmount = convertPrice(fd.totalAmount);
				return fd;
			});
		} else {
			formData.financeDeminimis = [];
		}

		return formData;
	}

	private createDeminimiGroup(fd: FinanceDeminimi): UntypedFormGroup {
		return this.fb.group({
			id: [fd.id],
			financier: [fd.financier, Validators.required],
			grantDate: [fd.grantDate ? dayjs(fd.grantDate) : null, [Validators.required, this.dateValidator]],
			totalAmount: [fd.totalAmount, Validators.required],
		});
	}

	private dateValidator(control: AbstractControl): ValidationErrors | null {
		if (control.value) {
			const now = new Date();
			const date = control.value as dayjs.Dayjs;

			if (date.year() + 2 < now.getFullYear()) {
				return {
					dateBefore: true,
				};
			}

			if (date.year() > now.getFullYear()) {
				return {
					dateAfter: true,
				};
			}
		}

		return null;
	}

	private totalValidator(group: AbstractControl): ValidationErrors | null {
		const total = group.value.financeDeminimis.reduce((sum: number, value: any) => sum + +value.totalAmount, 0);

		if (total > 200_000) {
			return {
				total: true,
			};
		}

		return null;
	}
}
